import { AxiosResponse } from 'axios';
import apiClient from './api';

const fileService = {
  createMediaFile: (file: FormData): Promise<AxiosResponse<any>> => {
    return apiClient.post(`/file/support/Media`, file);
  },

  createAttachmentFile: (file: FormData): Promise<AxiosResponse<any>> => {
    Array.from(file.entries()).forEach(([key, value]) => {
      console.log(key, value);
      if (value instanceof File) {
        console.log(`File details - Name: ${value.name}, Size: ${value.size}, Type: ${value.type}`);
      }
    });
    return apiClient.post(`/file/support/Attachment`, file);
  },

  getSupportFiles: (): Promise<AxiosResponse<any>> => {
    return apiClient.get(`/file/support`);
  },

  getFileByID: (fileID: string): Promise<AxiosResponse<ArrayBuffer>> => {
    return apiClient.get(`/file/${fileID}`, {
      responseType: 'arraybuffer',
    });
  },

  getFileByModule: (moduleID: number): Promise<AxiosResponse<any>> => {
    return apiClient.get(`/file/module/${moduleID}`);
  },

  deleteFile: (fileID: string): Promise<AxiosResponse<any>> => {
    return apiClient.delete(`/file/${fileID}`);
  },
};

export default fileService;